import { getRTCHTTPHeaders, RefreshAuthTradingCoreUrl, RequestMethods, sendHttpRequest } from '@repo/utils';

export const refreshTokenRequest = async () => {
  try {
    return await sendHttpRequest({
      url: RefreshAuthTradingCoreUrl,
      method: RequestMethods.Post,
      data: {},
      headers: getRTCHTTPHeaders(),
    });
  } catch (e: any) {
    console.log('Error; refreshTokenRequest; ', e);
    return { success: false };
  }
};
